/**
 * Unified Chat Service
 * API calls for unified conversation list, search, archive, and connection context
 */

import { apiClient } from "@/lib/api-client"
import type {
  ChatSearchResponse,
  ConnectionContext,
  UnifiedConversationListResponse,
} from "../types/unified-chat.types"

interface ApiResponse<T> {
  success: boolean
  data: T
  message: string
}

export async function listAllConversations(
  page = 1,
  limit = 20,
): Promise<UnifiedConversationListResponse> {
  const response = await apiClient.get<ApiResponse<UnifiedConversationListResponse>>(
    "/api/conversations/all",
    { params: { page, limit } },
  )
  return response.data.data
}

export async function searchConversations(
  query: string,
  page = 1,
  limit = 20,
): Promise<ChatSearchResponse> {
  const response = await apiClient.get<ApiResponse<ChatSearchResponse>>(
    "/api/conversations/search",
    { params: { q: query, page, limit } },
  )
  return response.data.data
}

export async function listArchivedConversations(
  page = 1,
  limit = 20,
): Promise<UnifiedConversationListResponse> {
  const response = await apiClient.get<ApiResponse<UnifiedConversationListResponse>>(
    "/api/conversations/archived",
    { params: { page, limit } },
  )
  return response.data.data
}

export async function archiveConversation(conversationId: string): Promise<void> {
  await apiClient.post(`/api/conversations/${conversationId}/archive`)
}

export async function unarchiveConversation(conversationId: string): Promise<void> {
  await apiClient.post(`/api/conversations/${conversationId}/unarchive`)
}

export async function getConnectionContext(userId: string): Promise<ConnectionContext | null> {
  const response = await apiClient.get<ApiResponse<ConnectionContext | null>>(
    `/api/conversations/connection/${userId}`,
  )
  return response.data.data
}
